import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DistributorParams } from 'src/app/models/shared-dto';
import Swal from 'sweetalert2';
import { RenaultDistributorDataModel } from '../../../models/renault-distributor';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-distributor-common-filter',
  templateUrl: './distributor-common-filter.component.html',
  styleUrls: ['./distributor-common-filter.component.scss']
})
export class DistributorCommonFilterComponent implements OnInit {

  @Input() multiDr = false;
  @Input() multiSector = false;
  @Input() multiVnPlate = false;
  @Input() multiPvGroup = false;
  @Input() multiSectionPv = false;
  @Input() multiDistri = false;
  @Input() idBrand;
  @Input() inputFilter: DistributorParams;
  hasInputFilter: boolean = false;

  @Input() hideDr = false;
  @Input() hideSector = false;
  @Input() hideVnPlate = false;
  @Input() hidePvGroup = false;
  @Input() hideSectionPv = true;
  @Input() hideDistri = false;

  @Input() hideResetFilter = false;

  @Input() requireDr = false;
  @Input() requireSector = false;
  @Input() requireVnPlate = false;
  @Input() requirePvGroup = false;
  @Input() requireSectionPv = false;
  @Input() requireDistri = false;

  @Input() showR2 = false;

  /**
   * filtersBreakLinePosition
   * fuerza el salto de línea dentro del formulario de filtros en la posición indicada
   */
  @Input() filtersBreakLinePosition = null;
  @Input() selectOnChange = false;

  @Output() modelFilterEmit = new EventEmitter<DistributorParams>();
  @Output() modelInputFilterEmit = new EventEmitter<DistributorParams>();
  @Output() uniquePvGroupUser = new EventEmitter<number>();
  modelFilter: DistributorParams = new DistributorParams();

  @Output() resetEmit = new EventEmitter<DistributorParams>();

  distributorParams: DistributorParams = new DistributorParams();

  drSelected;
  drData: any;
  sectorSelected;
  sectorData: any;
  vnPlateSelected;
  vnPlateData: any;
  grupopvSelected;
  grouppvData: any;
  sectionpvSelected;
  sectionpvData: any;
  distributorSelected;
  distributorData: any;

  userDistributors: RenaultDistributorDataModel[] = [];

  movedFields: boolean = false;


  constructor(private userService: UserService,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.loadUserDistributors();
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["idBrand"] && changes["idBrand"].currentValue != undefined && changes["idBrand"].previousValue != undefined) {
      this.distributorParams = new DistributorParams();
      this.modelFilter = this.distributorParams;
      this.distributorParams.IdBrand = +changes["idBrand"].currentValue;
      this.modelFilter.IdBrand = +changes["idBrand"].currentValue;
      this.loadDR();
    }

    if(changes.inputFilter && changes.inputFilter.currentValue) {
        this.hasInputFilter = true;
        this.inputFilter = changes.inputFilter.currentValue;
        this.distributorParams = this.inputFilter;
        this.modelFilter = this.inputFilter;
        this.loadDR();
        this.emitInputFilter();
    }

  }

  ngAfterViewChecked() {

    this.groupInputFields();

  }

  loadUserDistributors() {

    this.userService.getUserDistributors().subscribe(resp => {
      this.userDistributors = resp;
      if(!this.showR2) {
        this.userDistributors = this.userDistributors.filter(x => x.IdRelation == 1);
      }
      const uniquePvGroup = [...new Set(this.userDistributors.map((item) => item.IdPvGroup))];
      this.uniquePvGroupUser.emit(uniquePvGroup.length);
      if (this.inputFilter) {        
        this.hasInputFilter = true;
        this.distributorParams = this.inputFilter;
        this.modelFilter = this.inputFilter;
        this.loadDR();
        this.emitInputFilter();
      } else {
        this.distributorParams.IdBrand = +this.idBrand
        this.modelFilter.IdBrand = +this.idBrand;
        this.loadDR();
      }

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  loadDR() {

    if (this.idBrand == 2) {
      //DACIA
      const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
        [item["IdRegionDacia"], item])).values()];

      this.drData = arrayUniqueByKey.map((dr) => { return { value: dr.IdRegionDacia.toString(), label: dr.RegionDacia } }).sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    } else {
      //RENAULT
      const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
        [item["IdRegionRenault"], item])).values()];

      this.drData = arrayUniqueByKey.map((dr) => { return { value: dr.IdRegionRenault.toString(), label: dr.RegionRenault } }).sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    }

    if (this.drData.length == 1 && this.hideDr == false) {
      this.drSelected = this.multiDr ? [this.drData[0].value] : this.drData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.Region.length == 0) {
        this.drSelected = this.multiDr ? [] : "";
      } else {
        this.drSelected = this.multiDr ? this.inputFilter.Region : this.inputFilter.Region[0].toString();
      }
    }

    if(this.multiDr) this.selectDR();
    else this.loadSector();

  }

  loadSector() {

    this.distributorParams.Region = this.modelFilter.Region;

    if (this.idBrand == 2) {
      //DACIA
      const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
        [item["IdSectorDacia"], item])).values()];

      this.sectorData = arrayUniqueByKey.map((dr) => { return { value: dr.IdSectorDacia.toString(), label: dr.SectorDacia, idRegion: dr.IdRegionDacia.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    } else {
      //RENAULT
      const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
        [item["IdSectorRenault"], item])).values()];

      this.sectorData = arrayUniqueByKey.map((dr) => { return { value: dr.IdSectorRenault.toString(), label: dr.SectorRenault, idRegion: dr.IdRegionRenault.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    }

    if (this.distributorParams.Region.length > 0) {
      this.sectorData = this.sectorData.filter(x => this.distributorParams.Region.some(z => z == x.idRegion))
    }

    if (this.sectorData.length == 1 && this.hideSector == false) {
      this.sectorSelected = this.multiSector ? [this.sectorData[0].value] : this.sectorData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.Sector.length == 0) {
        this.sectorSelected = this.multiSector ? [] : "";
      } else {
        this.sectorSelected = this.multiSector ? this.inputFilter.Sector : this.inputFilter.Sector[0].toString();
      }
    }

    if(this.multiSector) this.selectSector();
    else this.loadVnPlate();

  }

  loadVnPlate() {

    this.distributorParams.Region = this.modelFilter.Region;
    this.distributorParams.Sector = this.modelFilter.Sector;

    const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
      [item["IdVnPlate"], item])).values()];

    if (this.idBrand == 2) {
      //DACIA
      this.vnPlateData = arrayUniqueByKey.map((dr) => { return { value: dr.IdVnPlate.toString(), label: dr.VnPlate, idRegion: dr.IdRegionDacia.toString(), idSector: dr.IdSectorDacia.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    } else {
      //RENAULT
      this.vnPlateData = arrayUniqueByKey.map((dr) => { return { value: dr.IdVnPlate.toString(), label: dr.VnPlate, idRegion: dr.IdRegionRenault.toString(), idSector: dr.IdSectorRenault.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    }

    if (this.distributorParams.Region.length > 0) {
      this.vnPlateData = this.vnPlateData.filter(x => this.distributorParams.Region.some(z => z == x.idRegion))
    }

    if (this.distributorParams.Sector.length > 0) {
      this.vnPlateData = this.vnPlateData.filter(x => this.distributorParams.Sector.some(z => z == x.idSector))
    }

    if (this.vnPlateData.length == 1 && this.hideVnPlate == false) {
      this.vnPlateSelected = this.multiVnPlate ? [this.vnPlateData[0].value] : this.vnPlateData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.VnPlate.length == 0) {
        this.vnPlateSelected = this.multiVnPlate ? [] : "";
      } else {
        this.vnPlateSelected = this.multiVnPlate ? this.inputFilter.VnPlate : this.inputFilter.VnPlate[0].toString()
      }
    }

    if(this.multiVnPlate) this.selectVnPlate();
    else this.loadPvGroup();

  }

  loadPvGroup() {

    this.distributorParams.Region = this.modelFilter.Region;
    this.distributorParams.Sector = this.modelFilter.Sector;
    this.distributorParams.VnPlate = this.modelFilter.VnPlate;

    const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
      [item["IdPvGroup"], item])).values()];

    if (this.idBrand == 2) {
      //DACIA
      this.grouppvData = arrayUniqueByKey.map((dr) => { return { value: dr.IdPvGroup.toString(), label: dr.PvGroup, idRegion: dr.IdRegionDacia.toString(), idSector: dr.IdSectorDacia.toString(), idVnPlate: dr.IdVnPlate.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    } else {
      //RENAULT
      this.grouppvData = arrayUniqueByKey.map((dr) => { return { value: dr.IdPvGroup.toString(), label: dr.PvGroup, idRegion: dr.IdRegionRenault.toString(), idSector: dr.IdSectorRenault.toString(), idVnPlate: dr.IdVnPlate.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    }

    if (this.distributorParams.Region.length > 0) {
      this.grouppvData = this.grouppvData.filter(x => this.distributorParams.Region.some(z => z == x.idRegion))
    }

    if (this.distributorParams.Sector.length > 0) {
      this.grouppvData = this.grouppvData.filter(x => this.distributorParams.Sector.some(z => z == x.idSector))
    }

    if (this.distributorParams.VnPlate.length > 0) {
      this.grouppvData = this.grouppvData.filter(x => this.distributorParams.VnPlate.some(z => z == x.idVnPlate))
    }

    if (this.grouppvData.length == 1 && this.hidePvGroup == false) {
      this.grupopvSelected = this.multiPvGroup ? [this.grouppvData[0].value] : this.grouppvData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.PvGroup.length == 0) {
        this.grupopvSelected = this.multiPvGroup ? [] : "";
      } else {
        this.grupopvSelected = this.multiPvGroup ? this.inputFilter.PvGroup : this.inputFilter.PvGroup[0].toString();
      }
    }

    if(this.multiPvGroup) this.selectGroupPV();
    else this.loadSectionPv();

  }

  loadSectionPv() {

    this.distributorParams.Region = this.modelFilter.Region;
    this.distributorParams.Sector = this.modelFilter.Sector;
    this.distributorParams.VnPlate = this.modelFilter.VnPlate;
    this.distributorParams.PvGroup = this.modelFilter.PvGroup;

    const arrayUniqueByKey = [...new Map(this.userDistributors.map(item =>
      [item["SectionPv"], item])).values()];

    if (this.idBrand == 2) {
      //DACIA
      this.sectionpvData = arrayUniqueByKey.map((dr) => { return { value: dr.SectionPv, label: dr.SectionPvName, idRegion: dr.IdRegionDacia.toString(), idSector: dr.IdSectorDacia.toString(), idVnPlate: dr.IdVnPlate.toString(), idPvGroup: dr.IdPvGroup.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    } else {
      //RENAULT
      this.sectionpvData = arrayUniqueByKey.map((dr) => { return { value: dr.SectionPv, label: dr.SectionPvName, idRegion: dr.IdRegionRenault.toString(), idSector: dr.IdSectorRenault.toString(), idVnPlate: dr.IdVnPlate.toString(), idPvGroup: dr.IdPvGroup.toString() } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    }

    if (this.distributorParams.Region.length > 0) {
      this.sectionpvData = this.sectionpvData.filter(x => this.distributorParams.Region.some(z => z == x.idRegion))
    }

    if (this.distributorParams.Sector.length > 0) {
      this.sectionpvData = this.sectionpvData.filter(x => this.distributorParams.Sector.some(z => z == x.idSector))
    }

    if (this.distributorParams.VnPlate.length > 0) {
      this.sectionpvData = this.sectionpvData.filter(x => this.distributorParams.VnPlate.some(z => z == x.idVnPlate))
    }

    if (this.distributorParams.PvGroup.length > 0) {
      this.sectionpvData = this.sectionpvData.filter(x => this.distributorParams.PvGroup.some(z => z == x.idPvGroup))
    }

    if (this.sectionpvData.length == 1 && this.hideSectionPv == false) {
      this.sectionpvSelected = this.multiSectionPv ? [this.sectionpvData[0].value] : this.sectionpvData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.SectionPv.length == 0) {
        this.sectionpvSelected = this.multiSectionPv ? [] : "";
      } else {
        this.sectionpvSelected = this.multiSectionPv ? this.inputFilter.SectionPv : this.inputFilter.SectionPv[0].toString();
      }
    }
    if(this.multiSectionPv) this.selectSectionPV();
    else this.loadDistributor();

  }

  loadDistributor() {

    this.distributorParams.Region = this.modelFilter.Region;
    this.distributorParams.Sector = this.modelFilter.Sector;
    this.distributorParams.VnPlate = this.modelFilter.VnPlate;
    this.distributorParams.PvGroup = this.modelFilter.PvGroup;
    this.distributorParams.SectionPv = this.modelFilter.SectionPv;

    if (this.idBrand == 2) {
      //DACIA
      this.distributorData = this.userDistributors.map((dr) => { return { value: dr.IdDistributor.toString(), label: dr.AccountNumber + ' - ' + dr.SocialName, idRegion: dr.IdRegionDacia.toString(), idSector: dr.IdSectorDacia.toString(), idVnPlate: dr.IdVnPlate.toString(), idPvGroup: dr.IdPvGroup.toString(), idSectionPv: dr.SectionPv } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    } else {
      //RENAULT
      this.distributorData = this.userDistributors.map((dr) => { return { value: dr.IdDistributor.toString(), label: dr.AccountNumber + ' - ' + dr.SocialName, idRegion: dr.IdRegionRenault.toString(), idSector: dr.IdSectorRenault.toString(), idVnPlate: dr.IdVnPlate.toString(), idPvGroup: dr.IdPvGroup.toString(), idSectionPv: dr.SectionPv } }).sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    }

    if (this.distributorParams.Region.length > 0) {
      this.distributorData = this.distributorData.filter(x => this.distributorParams.Region.some(z => z == x.idRegion))
    }

    if (this.distributorParams.Sector.length > 0) {
      this.distributorData = this.distributorData.filter(x => this.distributorParams.Sector.some(z => z == x.idSector))
    }

    if (this.distributorParams.VnPlate.length > 0) {
      this.distributorData = this.distributorData.filter(x => this.distributorParams.VnPlate.some(z => z == x.idVnPlate))
    }

    if (this.distributorParams.PvGroup.length > 0) {
      this.distributorData = this.distributorData.filter(x => this.distributorParams.PvGroup.some(z => z == x.idPvGroup))
    }

    if (this.distributorParams.SectionPv.length > 0) {
      this.distributorData = this.distributorData.filter(x => this.distributorParams.SectionPv.some(z => z == x.idSectionPv))
    }
    if (this.distributorData.length == 1 && this.hideDistri == false) {
      this.distributorSelected = this.multiDistri ? [this.distributorData[0].value] : this.distributorData[0].value;
    }
    else {
      if (!this.hasInputFilter || this.hasInputFilter && this.inputFilter.Distributor.length == 0) {
        this.distributorSelected = this.multiDistri ? [] : "";
      } else {
        this.distributorSelected = this.multiDistri ? this.inputFilter.Distributor : this.inputFilter.Distributor[0].toString();
      }
    }
    if(this.multiDistri) this.selectDistri();
    this.hasInputFilter = false;
  }

  selectDR() {
    if (this.drSelected !== undefined) {
      this.modelFilter.Region = this.multiDr ? this.drSelected : [this.drSelected];
    } else {
      this.modelFilter.Region = [];
    }
    if (this.selectOnChange) this.emitFilter();
    this.loadSector();
  }

  selectSector() {
    if (this.sectorSelected !== undefined) {
      this.modelFilter.Sector = this.multiSector ? this.sectorSelected : [this.sectorSelected];
    } else {
      this.modelFilter.Sector = [];
    }
    if (this.selectOnChange) this.emitFilter();
    this.loadVnPlate();
  }

  selectVnPlate() {
    if (this.vnPlateSelected !== undefined) {
      this.modelFilter.VnPlate = this.multiVnPlate ? this.vnPlateSelected : [this.vnPlateSelected];
    } else {
      this.modelFilter.VnPlate = [];
    }
    if (this.selectOnChange) this.emitFilter();
    this.loadPvGroup();
  }

  selectGroupPV() {
    if (this.grupopvSelected !== undefined) {
      this.modelFilter.PvGroup = this.multiPvGroup ? this.grupopvSelected : [this.grupopvSelected];
    } else {
      this.modelFilter.PvGroup = [];
    }
    if (this.selectOnChange) this.emitFilter();
    this.loadSectionPv();
  }

  selectSectionPV() {
    if (this.sectionpvSelected !== undefined) {
      this.modelFilter.SectionPv = this.multiSectionPv ? this.sectionpvSelected : [this.sectionpvSelected];
    } else {
      this.modelFilter.SectionPv = [];
    }
    if (this.selectOnChange) this.emitFilter();
    this.loadDistributor();
  }

  selectDistri() {
    if (this.distributorSelected !== undefined) {
      this.modelFilter.Distributor = this.multiDistri ? this.distributorSelected : [this.distributorSelected];
    }
    else {
      this.modelFilter.Distributor = [];
    }
    if (this.selectOnChange) this.emitFilter();
  }

  cleanFilters() {
    this.modelFilter = new DistributorParams();
    this.drSelected = this.multiDr ? [] : "";
    this.sectorSelected = this.multiSector ? [] : "";
    this.vnPlateSelected = this.multiVnPlate ? [] : "";
    this.grupopvSelected = this.multiPvGroup ? [] : "";
    this.distributorSelected = this.multiDistri ? [] : "";
    this.resetEmit.emit(this.modelFilter);
    this.loadDR();
  }

  emitFilter() {
    this.modelFilterEmit.emit(this.modelFilter);
  }

  emitInputFilter() {
    this.modelInputFilterEmit.emit(this.modelFilter);
  }

  emitReset() {
    this.cleanFilters();
  }

  groupInputFields() {

    //console.log('groupInputFields');

    // setTimeout(() => {
    //   const that = this;

    //   $($(".cont__filters_fields:not(.not-group) > div").get().reverse()).each(function (i) {
    //     if (!that.movedFields) {
    //       $(this).prependTo('app-distributor-common-filter').addClass('grouped');
    //       that.movedFields = true;
    //     } else {
    //       $(".grouped").after($(this));
    //       $(".grouped").removeClass("grouped");
    //       $(this).addClass("grouped");
    //     }
    //   });
    //   $("app-distributor-common-filter > div").addClass('col-sm-6 col-md-4 col-lg-3 mb-3').removeClass('col');
    // }, 500);
  }

}


